import Vue from "vue";
import 'ant-design-vue/dist/antd.css';
import {
  Button,
  Checkbox,
  ConfigProvider,
  DatePicker,
  Divider,
  Dropdown,
  Empty,
  Icon,
  Input,
  InputNumber,
  Layout,
  message,
  Menu,
  Modal,
  Form,
  FormModel,
  Pagination,
  Popconfirm,
  Popover,
  Radio,
  Row,
  Col,
  Select,
  Spin,
  Switch,
  Table,
  Tree,
  TreeSelect,
  Tabs,
  Tag,
  Tooltip,
  Upload,
  Cascader,
  notification,
  Result,
  Slider,
  BackTop,
} from "ant-design-vue";

Vue.use(ConfigProvider);
Vue.use(Dropdown);
Vue.use(Pagination);
Vue.use(Select);
Vue.use(Button);
Vue.use(Checkbox);
Vue.use(Divider);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Row);
Vue.use(Col);
Vue.use(Popconfirm);
Vue.use(Popover);
Vue.use(Radio);
Vue.use(Switch);
Vue.use(Tree);
Vue.use(TreeSelect);
Vue.use(Tag);
Vue.use(Tabs);
Vue.use(Tooltip);
Vue.use(Cascader);
Vue.use(Form);
Vue.use(Modal); // 用于修复警告 Failed to resolve directive: ant-portal
Vue.use(FormModel); // 用于修复警告 Failed to resolve directive: ant-portal
Vue.use(DatePicker); // 用于修复警告 Failed to resolve directive: ant-portal
Vue.use(Spin);
Vue.use(Menu);
Vue.use(Layout);
Vue.use(Table);
Vue.use(Result);
Vue.use(Empty);
Vue.use(Upload);
Vue.use(Upload.Dragger);
Vue.use(Icon);
Vue.use(Slider);
Vue.use(BackTop);

Vue.prototype.$message = message;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$success = Modal.success;
Vue.prototype.$info = Modal.info;
Vue.prototype.$error = Modal.error;
Vue.prototype.$warning = Modal.warning;
Vue.prototype.$notification = notification;

